var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColor = function SvgColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10a4 4 0 0 1-8 0c0-1.02.633-1.971 1.416-3.147.689-1.034 1.493-2.242 2.086-3.826.192-.513.824-.525 1.019-.017.597 1.554 1.377 2.73 2.046 3.742C11.361 7.95 12 8.915 12 10zm-3.2.188c-.316.453-.726 1.195-.274 1.512.452.317 1.321-.107 1.638-.56.317-.452.453-1.451 0-1.768-.452-.317-1.046.364-1.363.816z"
  })));
};
export default SvgColor;